import React from "react";
import RunJobButton from "../RunJobButton";
import RunHarmonizationButton from "../RunHarmonizationButton";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  makeStyles,
} from "@material-ui/core";
import { Grid } from "@material-ui/core";

// const useStyles = makeStyles((theme) => ({
//   root: {
//     // flexGrow: 1,
//   },
//   menuButton: {
//     marginRight: theme.spacing(2),
//     color: "black",
//   },
//   title: {
//     flexGrow: 1,
//     color: "balck",
//   },

//   typography: {
//     fontFamily: "Calibri",
//   },

//   breakpoints: {
//     values: {
//       mobile: 0,
//       tablet: 640,
//       laptop: 1024,
//       desktop: 1200,
//     },
//   },

//   LMAText: {
//     color: "black",
//     fontFamily: "Calibri",
//     fontSize: "18px",
//     fontWeight: "bold",
//     alignItems: "center",
//   },

//   muiAppBarColorPrimary: {
//     color: "#fff",
//     backgroundColor: "#ffffff",
//   },
// }));

// Pass User
const Home = ({ user }) => {
  const logout = () => {
    localStorage.removeItem("user");
    window.location.reload();
  };
  // const classes = useStyles();

  return (
    <>
      <Grid container>
        {/*    // <Grid item xs ={8} style={{
      //       // border: "1px solid blue", 
      //       // marginTop: "5px"
      //     }}>
      //     <div style={{ textAlign: "left", margin: "1rem" }}>
      //       <Typography className={classes.LMAText}>
      //         {/*Logged in as: {user?.email}  for login info*/}
        {/*    //       </Typography>
      //     {/* <p>
      //     You are viewing this page because you are logged in.
      //     </p> */}
        {/*    //     </div>
      // </Grid>

      // <Grid item xs ={4} style={{
      //   // border: "1px solid blue",
      //   // marginTop: "5px",
      //   display: "flex",
      //   justifyContent: "flex-end",
      //   }}>
      //     <Typography>
      //       <div>
      //         <button
      //           onClick={logout}
      //           style={{
      //             color: "black",
      //             borderRadius: "10px",
      //             backgroundColor: "white",
      //             padding: "0.5rem 1rem",
      //             marginRight: "10px",
      //             cursor: "pointer",
      //           }}
      //         >
      //         <div>{user?.email}</div>
      //           Logout
      //         </button>
      //       </div>
      //     </Typography>
      // </Grid>
      <Grid item xs ={12} style={{
            // border: "1px solid blue", 
            // marginTop: "5px"
          }}>

        {/*<LMAFormMixed historicalActivity={historicalActivity} setHistoricalActivity={setHistoricalActivity}/>*/}

        <Grid item xs={12}>
          <AppBar position="static" color="inherit">
            <Toolbar
              sx={{
                display: "flex",
                justifyContent: "center",
                position: "relative",
              }}
            >
              <Grid style={{ padding: "20px" }}></Grid>
              <Typography
                variant="h6"
                sx={{ position: "absolute", left: "1rem" }}
              >
                Naomi
              </Typography>

              {/* Right Side - User Email & Logout Button */}
              <Box
                sx={{
                  marginLeft: "auto",
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                {user?.email && (
                  <Typography
                    sx={{
                      marginTop: "20px",
                      marginBottom: "50px",
                      backgroundColor: "white",
                      color: "black",
                      borderRadius: "10px",
                      padding: "0.5rem 1rem",
                      border: "1px solid black",
                      "&:hover": { backgroundColor: "#f0f0f0" },
                    }}
                  >
                    {user.email}
                  </Typography>
                )}
                <Button
                  onClick={logout}
                  sx={{
                    marginTop: "20px",
                    marginBottom: "50px",
                    backgroundColor: "white",
                    color: "black",
                    borderRadius: "10px",
                    padding: "0.5rem 1rem",
                    border: "1px solid black",
                    "&:hover": { backgroundColor: "#f0f0f0" },
                  }}
                >
                  Logout
                </Button>
              </Box>
            </Toolbar>
          </AppBar>
        </Grid>
        <Grid
          item
          xs={12}
          
        >
          <Grid
            item
            xs={5}
            style={{
              // border: "1px solid blue",
              margin: "auto",
              display: "flex",
              justifyContent: "center",
              gap: 2,
            }}
          >
            <RunJobButton />
          </Grid>
          <Grid
            item
            xs={2}
            style={{ 
              // border: "1px solid black", 
              marginTop: "5px", justifyContent: "center" }}
          ></Grid>
          <Grid
            item
            xs={5}
            style={{
              // border: "1px solid red",
              margin: "auto",
              display: "flex",
              justifyContent: "center",
              gap: 2,
            }}
          >
            {/*<LMAFormMixed historicalActivity={historicalActivity} setHistoricalActivity={setHistoricalActivity}/>*/}
            <RunHarmonizationButton />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Home;
